document.addEventListener('DOMContentLoaded', async function() {
  let response


  const fetchDrawerData = async () => {
        // let treatments = null;
        // let retries = 0;
        // const maxRetries = 40; // 40 Versuche = 10 Sekunden
        // const tryLoadTreatments = async () => {
        //   const isLoading = window.treatmentsQuery.isLoading();
      
        //   if (!isLoading) {
        //     const treatments = await window.treatmentsQuery.getAll();
        //     return treatments
        //   } else if (retries < maxRetries) {
            
        //     retries++;
        //     setTimeout(tryLoadTreatments, 250);
        //   } else {
        //     console.warn("❌ Max. Wiederholungen erreicht. Daten konnten nicht geladen werden.");
        //   }
        // };
        // tryLoadTreatments()  
    return await callAPI({endpoint: `/treatments/plattform-get-treatments?pageType=${encodeURIComponent(pageType)}&pageId=${encodeURIComponent(pageId)}`})
  }


  
  function formatToURLPath(str) {
    const umlautMap = {
        'ä': 'ae', 'ö': 'oe', 'ü': 'ue', 'ß': 'ss',
        'Ä': 'ae', 'Ö': 'oe', 'Ü': 'ue'
    };
    let formattedStr = str.trim().replace(/[äöüÄÖÜß]/g, match => umlautMap[match]);
    
    // Ersetze Leerzeichen mit Bindestrichen und wandle in lowercase um
    formattedStr = formattedStr.replace(/\s+/g, '-').toLowerCase();
    return formattedStr;
  }


  //////////////////////// sort treatments by ap //////////////////////////////////////
  function sortTreatmentsByAestheticPoint(treatments) {
    const sortedTreatments = treatments.sort((a, b) => {
      return a.user_aesthetic_point.localeCompare(b.user_aesthetic_point);
    });
    return sortedTreatments
  }


  ////////////    Öffnen des Drawers über Buttons mit der Klasse "open-drawer-btn"   //////////////
  document.body.addEventListener('click', function(e) {
    const drawerBtn = e.target.closest('.open-drawer-btn');
    if (drawerBtn) {
      openDrawer();
      document.body.style.overflow = "hidden";
    }
  });

  ////////////            Schließen per Klick auf das X             ////////////////////////
  const closeDrawerBtn = document.getElementById('close-drawer-btn');
  if (closeDrawerBtn) {
    closeDrawerBtn.addEventListener('click', function() {
      closeDrawer();
      document.body.style.overflow = "";
    });
  }
  
  const drawerOpacitybackground = document.getElementById('drawer-opacity-background');
  if(drawerOpacitybackground) {
    drawerOpacitybackground.addEventListener('click', function() {
      closeDrawer();
      document.body.style.overflow = "";
    });
  }
  
  const drawer = document.getElementById('drawer');
  if (!drawer) console.log("kein drawer mit 'getElementById' gefunden");
  
      // Lese die Data-Attribute aus
  const pageType = drawer.getAttribute('data-page-type');
  const pageId   = drawer.getAttribute('data-page-id');
  if(!response || !response?.data) {
    response = await fetchDrawerData()
  }

  async function renderDrawerData() {
    const drawer = document.getElementById('drawer');
    if (!drawer) console.log("kein drawer mit 'getElementById' gefunden");
    // Lese die Data-Attribute aus
    if(!response || !response?.data) {
      response = await fetchDrawerData()
    }
    const pageType = drawer.getAttribute('data-page-type');
    const pageId   = drawer.getAttribute('data-page-id');
    const introsLogo   = drawer.getAttribute('data-intros-logo');
    if(response && response.data) {   
      const elementDoctorList = document.getElementById("drawer-doctor-list");
      const treatmentList = response.data
      const sortedTreatments = sortTreatmentsByAestheticPoint(treatmentList.filter(treatment => treatment.user_aesthetic_point))

      elementDoctorList.innerHTML = sortedTreatments.map(item => {
        const treatmentItem = item.treatments.find(treatment => treatment.id === pageId)
        if(!item.user_aesthetic_point) return

        const currentPath = window.location.pathname;


        const isApPage = currentPath.includes('pages/aesthetic-point')
        const isLandingPage = currentPath === "/"
        

        // altes <a> um auf die ap seite zu leiten
        //  <a href="/pages/${formatToURLPath(item.user_aesthetic_point)}?product=${pageId}" style="display: flex; justify-content: space-between; align-items: center">
        return `<div class="doctor-item" >
                  ${isApPage || isLandingPage
                    ? `<a href="/pages/${formatToURLPath(item.user_aesthetic_point)}" style="display: flex; justify-content: space-between; align-items: center">`
                    : `<a href="${currentPath}?campaignname=${item.user_aesthetic_point.replace("Aesthetic Point ", "")}" style="display: flex; justify-content: space-between; align-items: center">`
                  }
                  
                    <div>
                      <p style="margin: 0px; padding: 0px; font-weight: bold; line-height: 1.5; display: flex; align-items:center; gap: 8px;">
                        ${item?.user_aesthetic_point.replace("Aesthetic Point ", "")} 
                        ${item?.has_intros ? `<img src="${introsLogo}" width="44px"  alt="intro icon" />` : ''}
                      </p>
                      <p style="margin: 0px; padding: 0px; font-size: 10px; line-height: 1">${item?.user_address}</p>
                    </div>
                    ${pageType === 'product' && !treatmentItem.is_medical ? `<p style="font-size: 12px; margin: 0; font-weight: bold">ab: ${Math.ceil(treatmentItem.price)} €</p>` : ''}
                  </a>
                </div>`;
      }).join('');
    }
}



  function openDrawer() {
    const drawer = document.getElementById('drawer');
    const drawerOpacitybackground = document.getElementById('drawer-opacity-background');
    if(drawerOpacitybackground) {
      drawerOpacitybackground.classList.remove('hidden')  
    }
    if (drawer) {
      drawer.classList.remove('hidden');
      void drawer.offsetWidth;
      drawer.classList.add('open');
      renderDrawerData();
    }
  }

  function closeDrawer() {
    const drawer = document.getElementById('drawer');
    const drawerOpacitybackground = document.getElementById('drawer-opacity-background');
    if(drawerOpacitybackground) {
      drawerOpacitybackground.classList.add('hidden')  
    }
    if (drawer) {
      // Transition vorübergehend deaktivieren, damit kein Schließ-Animationseffekt auftritt
      drawer.style.transition = 'none';
      // Entferne die Klasse .open, damit der Drawer sofort in den Ausgangszustand geht
      drawer.classList.remove('open');
      // Erzwinge einen Reflow, damit die Änderung übernommen wird
      void drawer.offsetWidth;
      // Setze sofort .hidden, damit der Drawer komplett ausgeblendet wird
      drawer.classList.add('hidden');
      // Transition wieder aktivieren (für das nächste Öffnen)
      setTimeout(() => {
        drawer.style.transition = '';
      }, 10);
    }
  }
});